module.exports = __webpack_public_path__ + "static/img/strona_030.9eb0bc08.jpg";